
import { Routes } from '@angular/router';

// LANDING PAGE
import { HomeComponent } from './pages/home/home.component';
import { QuemSomosComponent } from './pages/quem-somos/quem-somos.component';
import { PoliticaPrivacidadeComponent } from './pages/politica-de-privacidade/politica-de-privacidade.component';
import { TermosUsoComponent } from './pages/termos-de-uso/termos-de-uso.component';
import { CheckoutComponent } from './pages/checkout/checkout.component';


// GUARDS
import { authGuard } from './core/guards/auth.guard';
import { Login } from './pages/auth/login/login';
import { PrimeiroAcesso } from './pages/auth/primeiro-acesso/primeiro-acesso';
import { AdminDashboard } from './pages/admin/dashboard/dashboard';
import { Assinaturas } from './pages/admin/assinaturas/assinaturas';
import { Parceiros } from './pages/admin/parceiros/parceiros';
import { Usuarios } from './pages/parceiro/usuarios/usuarios';
import { ParceiroDashboard } from './pages/parceiro/dashboard/dashboard';
import { BackofficeLayout } from './pages/layouts/backoffice-layout/backoffice-layout';
import {ParceiroLembretesComponent} from './pages/parceiro/lembretes/parceiro-lembretes.component';


export const routes: Routes = [

  // LANDING PAGE
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'quem-somos',
    component: QuemSomosComponent
  },
  {
    path: 'politica-de-privacidade',
    component: PoliticaPrivacidadeComponent
  },
  {
    path: 'termos-de-uso',
    component: TermosUsoComponent
  },
  {
    path: 'checkout',
    component: CheckoutComponent
  },

  // AUTENTICAÇÃO
  {
    path: 'login',
    component: Login
  },
  {
    path: 'primeiro-acesso',
    component: PrimeiroAcesso
  },

  // BACKOFFICE ADMIN
  {
    path: 'admin',
    component: BackofficeLayout,
    canActivate: [authGuard],
    data: { roles: ['ADMIN'] },
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        component: AdminDashboard
      },
      {
        path: 'assinaturas',
        component: Assinaturas
      },
      {
        path: 'parceiros',
        component: Parceiros
      }
    ]
  },

  // BACKOFFICE PARCEIRO
  {
    path: 'parceiro',
    component: BackofficeLayout,
    canActivate: [authGuard],
    data: { roles: ['PARCEIRO'] },
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        component: ParceiroDashboard
      },
      {
        path: 'usuarios',
        component: Usuarios
      },
      {
        path: 'lembretes',
        component: ParceiroLembretesComponent
      }
    ]
  },

  // ROTA NÃO ENCONTRADA
  {
    path: '**',
    redirectTo: ''
  }
];
